export default "__VITE_ASSET__Gj_lRJsM__"